module.exports = __webpack_public_path__ + "static/media/29.ae22e7d0.jpg";